import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkApi } from '../index.d'

export const accEntryXLSX = createAsyncThunk<any, Record<string, any>, ThunkApi>(
  '[ACC_ENTRY] XLSX',
  async (params, { extra, rejectWithValue }) => {
    const result = await extra.api.accEntry.xlsx(params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)

export const accEntryXLSXImportFile = createAsyncThunk<any, Record<string, any>, ThunkApi>(
  '[ACC_ENTRY] XLSX_IMPORT_FILE',
  async (params, { extra, rejectWithValue }) => {
    const result = await extra.api.accEntry.xlsxFile('import', params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)

export const accEntryXLSXViewFile = createAsyncThunk<any, Record<string, any>, ThunkApi>(
  '[ACC_ENTRY] XLSX_VIEW_FILE',
  async (params, { extra, rejectWithValue }) => {
    const result = await extra.api.accEntry.xlsxFile('view', params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)
